module.exports = __webpack_public_path__ + "img/PRINT.9e4e31ed.svg";